export const base64urlDecode = (str: string) => {
	const base64String = str.replace(/-/g, "+").replace(/_/g, "/")
	return atob(base64String)
}

// BE (lib_.strings.urlsafe_base64_encode) と同じく padding を残した base64url を返す
export const base64urlEncode = (str: string) => {
	return btoa(str).replace(/\+/g, "-").replace(/\//g, "_")
}
